import posthog from "posthog-js";

/**
 * Fire from a scribe-attachment `<Image>`'s `onLoad` once the browser has
 * actually fetched and decoded the bytes. `compressed` is true when the
 * rendered URL was the thumbnail; false when the caller fell back to the
 * full-resolution signed URL because no thumbnail was available.
 *
 * Tenant is auto-stamped on every captured event by `instrumentation-client.ts`.
 */
export function reportScribeAttachmentLoaded(compressed: boolean): void {
  posthog.capture("scribe_attachment_loaded", { compressed });
}
